import React, { useEffect, useState } from 'react';
import { fetchAllUnits } from 'services';
import { showError, sortArray } from 'utils';

const InventoryItemUnitDropwdown = props => {
  const [allUnits, setAllUnits] = useState<Record<string, any>[]>([]);
  const [unitsLoading, setUnitsLoading] = useState<boolean>(false);
  const { value, loading, onSelect } = props;
  
  const fetchAllUnitsFn = async () => {
    setUnitsLoading(true);
    try {
      const response = await fetchAllUnits();
      setAllUnits(response);
    } catch (e) {
      showError(e);
    } finally {
      setUnitsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllUnitsFn();
  }, []);

  const handleSelect = (id: string) => {
    onSelect(id);
  };
  
  return (
    <div>
      <select
        value={value}
        disabled={loading || unitsLoading}
        onChange={e => handleSelect(e.target.value)}
        className={'form-control w-100'}
      >
        <option hidden={!!value} value={undefined}>Choose a unit</option>
        {sortArray(allUnits, 'description').map((unit, i) => (
          <option key={i} value={unit.objectId}>{unit.description}</option>
        ))}
      </select>
    </div>
  );
};

export default InventoryItemUnitDropwdown;